import { render, staticRenderFns } from "./workAdviceWidge.vue?vue&type=template&id=4ce54b7d&scoped=true"
import script from "./workAdviceWidge.vue?vue&type=script&lang=js"
export * from "./workAdviceWidge.vue?vue&type=script&lang=js"
import style0 from "./workAdviceWidge.vue?vue&type=style&index=0&id=4ce54b7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce54b7d",
  null
  
)

export default component.exports